import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { SET_ROUTE } from 'estimate_list/reducers/initial'

const Tab = () => {
    const { route, lists, selectCategory, domain } = useSelector(state => state.initial)

    const dispatch = useDispatch()

    const onClickTab = tab => () => {
        dispatch({
            type: SET_ROUTE,
            data: { tab }
        })
    }

    return (
        <TabsFilter>
            <li className={`${route.tab === 'total' ? 'active' : ''}`}>
                <Link to={`/list/${selectCategory}`} className="filter" onClick={onClickTab('total')}>
                    {domain === 'shopping' ? '가격' : domain === 'pc' && '견적'}비교<span className="num">{lists.itemList.total}</span>
                </Link>
            </li>
            <li className={`${route.tab === 'curation' ? 'active' : ''}`}>
                <Link to={`/list/${selectCategory}/curation`} className="filter" onClick={onClickTab('curation')}>
                    큐레이션
                </Link>
            </li>
            <li className={`${route.tab === 'mguide' ? 'active' : ''}`}>
                <Link to={`/list/${selectCategory}/mguide`} className="filter" onClick={onClickTab('mguide')}>
                    미디엄 가이드
                </Link>
            </li>
            <li className={`${route.tab === 'mreview' ? 'active' : ''}`}>
                <Link to={`/list/${selectCategory}/mreview`} className="filter" onClick={onClickTab('mreview')}>
                    미디엄 뉴스 & 리뷰
                </Link>
            </li>
        </TabsFilter>
    )
}

const TabsFilter = styled.ul`
    border-bottom: 2px solid #418ded;

    &:after {
        content: '';
        display: block;
        clear: both;
    }
    li {
        float: left;

        .filter {
            display: block;
            width: 180px;
            height: 45px;
            background: #f7f7f7;
            border: 1px solid #c8c8c8;
            border-bottom: none;
            font-size: 16px;
            font-weight: 700;
            color: #999;
            display: block;
            line-height: 40px;
            text-align: center;

            .num {
                margin: 0 0 0 4px;
                font-size: 12px;
                font-weight: 400;
            }
        }
        &.active {
            .filter {
                background: #418ded;
                border: 1px solid #418ded;
                color: #fff
            }
        }
        & + li .filter {
            border-left: 0;
        }
    }
`

export default Tab



// WEBPACK FOOTER //
// ./src/estimate_list/pages/tab/components/tab.js